import {
  Create,
  SimpleForm,
} from "react-admin";

import useCreateWithValidation from "../common/useCreateWithValidation";
import ServiceBookingFields from "./fields";

const ServiceBookingCreate = () => {
  const save = useCreateWithValidation("ServiceBooking", {
    redirectTo: "list",
    transform: sanitizeServiceBooking,
  });

  return (
    <Create>
      <SimpleForm
        onSubmit={save}
        defaultValues={{
          canceledOn: null,
          invoicedUntil: null,
          discountPercent: 0.0,
        }}
      >
        <ServiceBookingFields />
      </SimpleForm>
    </Create>
  );
};

export default ServiceBookingCreate;

export const sanitizeServiceBooking = (data: any) => {
  if (data.serviceTemplate) {
    delete data.serviceTemplate;
  }
  if (data.sepaBilling) {
    delete data.sepaBilling.__typename;
  }

  if (data.customerId && data.customer) {
    delete data.customer;
  }

  return data;
};
